import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import Dashboard from '@/modules/dashboard/views/Dashboard.vue'

const baseRoute = '/dashboard'

const dashboardRouter = [
  {
    path: `${baseRoute}/overview`,
    name: 'dashboard',
    meta: {
      component: Dashboard
    },
    component: PrivateRouter,
  }
]

export default dashboardRouter
